<template>
  <div class="login_contenter">
    <loginHeader></loginHeader>
    <div class="login_content" :class="{isPopFrame}">
      <div class="login_cont" :data-w="windowInnerWidth">
        <div class="login_form">
          <closeModalBtn ref="closeModalBtn"/>
          <div class="login_type">
            <span class="login_type_item" v-show="['wx', 'dd'].includes(loginType)" :class="{'active': ['wx', 'dd'].includes(loginType)}">{{ $t('WeiXinDengLu', [SFName]) }}</span>
            <span class="login_type_item" v-show="!['wx', 'dd'].includes(loginType)" :class="{'active': loginType === 'tel'}" @click="typeChange('tel')">{{ $t('YanZhengMaDengLu') }}</span>
            <span class="login_type_item" v-show="!['wx', 'dd'].includes(loginType)" :class="{'active': loginType === 'pwd'}" @click="typeChange('pwd')">{{ $t('MiMaDengLu') }}</span>
          </div>
          <div class="login_item" v-show="['wx', 'dd'].includes(loginType)">
            <div v-if="loginType === 'wx'" id="login_container">
              <img v-show="QrCode" :src="QrCode" :alt="$t('WeiXinDengLu', [$t('weiXin')])" width="224" height="224">
              <div v-show="!QrCode" class="loadCont">
                <div class="wx_loading">
                  <div class="load">
                    <div class="load_white"></div>
                  </div>
                </div>
              </div>
            </div>
            <DDLogin v-if="loginType === 'dd'" @loginSuccess="loginIsSuccessfullyRedirected" :isKeepMore="isKeepMore"></DDLogin>
            <div v-if="loginType === 'wx'" class="wx_text">{{ $t('QingShiYongWeiXinSaoMiaoErWeiMaDengLu', [SFName]) }}</div>
            <div class="sy_login_bottom">
              <el-checkbox class="remember_me" v-model="isKeepMore">{{ $t('30TianNeiJiZhuWo') }}</el-checkbox>
              <div @click="typeChange('tel')" style="cursor: pointer;color: var(--font-color)">{{ $t('QiTaDengLuFangShi') }}<i class="el-icon-right"></i></div>
            </div>
          </div>
          <div class="login_item" v-show="loginType==='tel'">
            <div class="login_form_cont">
              <el-form :rules="rules" ref="loginTelForm" :model="telForm" label-width="0px" size="medium">
                <el-form-item prop="tel">
                  <el-input v-model="telForm.tel" :placeholder="$t('ShouJiHaoYouXiang')" :readonly="btnStatus.loginNoteBtn" auto-complete="false"></el-input>
                </el-form-item>
                <el-form-item prop="verificationCode" v-if="showCaptcha.codeLogin">
                  <el-input v-model="telForm.verificationCode" :placeholder="$t('TuXingYanZhengMa')" style="width: calc(100% - 150px);" :readonly="btnStatus.loginNoteBtn" auto-complete="false" maxlength="6"></el-input>
                  <img class="imgCode" @click="loginChangeCodeFn('loginNoteImgCode')" :src="imgCodeData.loginNoteImgCode" :alt="$t('YanZhengMa')" :title="$t('DianJiQieHuanYanZhengMa')">
                </el-form-item>
                <el-form-item prop="telVerificationCode">
                  <el-input v-model="telForm.telVerificationCode" :placeholder="$t('YanZhengMa')" maxlength="6" :readonly="btnStatus.loginNoteBtn" auto-complete="false"></el-input>
                  <el-button class="getNoteCodeBtn" type="text" @click="getNoteCode" :disabled="noteCodeBtn">{{telCodeText}}</el-button>
                </el-form-item>
                <el-form-item prop="checked" class="protocol">
                  <el-checkbox v-model="telForm.checked" :disabled="btnStatus.loginNoteBtn">
                    <i18n path="WoYiYueDuBingTongYi">
                      <template #tos>
                        <el-link class="sy_reg_atc" type="primary" :href="$urls.dtranxUrl + '/home/UserAgreement?locale=' + language" target="_blank">
                          {{ $t('YongHuXieYi') }}
                        </el-link>
                      </template>
                      <template #privacy>
                        <el-link type="primary" class="sy_reg_atc" :href="$urls.dtranxUrl + '/home/PrivacyPolicy?locale=' + language" target="_blank">
                          {{ $t('YinSiShengMing') }}
                        </el-link>
                      </template>
                    </i18n>
                  </el-checkbox>
                </el-form-item>
                <el-form-item class="protocol">
                  <el-checkbox v-model="isKeepMore" :disabled="btnStatus.loginNoteBtn">{{ $t('30TianNeiJiZhuWo') }}</el-checkbox>
                </el-form-item>
                <el-form-item size="large">
                  <el-button type="primary" class="loginBtn" @click="telSubmit" :loading="btnStatus.loginNoteBtn">{{ $t('DengLu') }}</el-button>
                </el-form-item>
              </el-form>
              <div class="sy_auto_explain">{{ $t('WeiZhuCeDeShouJiHaoYouXiangYanZhengChengGongHouJiangZiDongZhuCe') }}</div>
            </div>
          </div>
          <div class="login_item" v-show="loginType==='pwd'">
            <div class="login_form_cont pwd_mb" :class="{verificationCode: showCaptcha.pwdLogin}">
              <el-form :rules="pwdRules" ref="loginPwdForm" :model="pwdForm" label-width="0px" size="medium">
                <el-form-item prop="telEmail">
                  <el-input v-model="pwdForm.telEmail" :readonly="btnStatus.loginPwdBtn" :placeholder="$t('ShouJiHaoYouXiang')"></el-input>
                  <span class="item-error el-form-item__error" slot="error">
                    {{checkTelEmailErrorMsg}}
                    <a v-show="toRegister" @click="toRegisterFn" style="cursor: pointer;">{{ $t('QuZhuCe') }}&gt;&gt;</a>
                  </span>
                </el-form-item>
                <el-form-item prop="telPwd">
                  <el-input v-model="pwdForm.telPwd" :readonly="btnStatus.loginPwdBtn" :placeholder="$t('MiMa')" :type="!showPwdIcon?'password':'text'" :clearable="windowInnerWidth > 499">
                    <i slot="suffix" class="el-input__icon iconfont" @click="showPwdFn" :class="{'yyq-icon-hide': !showPwdIcon, 'yyq-icon-view': showPwdIcon}"></i>
                  </el-input>
                </el-form-item>
                <el-form-item prop="verificationCode" v-if="showCaptcha.pwdLogin">
                  <el-input v-model="pwdForm.verificationCode" :readonly="btnStatus.loginPwdBtn" :placeholder="$t('TuXingYanZhengMa')" style="width: calc(100% - 150px);;" auto-complete="false"></el-input>
                  <img class="imgCode" @click="loginChangeCodeFn('loginPwdImgCode')" :src="imgCodeData.loginPwdImgCode" :alt="$t('YanZhengMa')" :title="$t('DianJiQieHuanYanZhengMa')">
                </el-form-item>
                <el-form-item prop="checked" class="protocol">
                  <el-checkbox v-model="pwdForm.checked" :disabled="btnStatus.loginPwdBtn">
                    <i18n path="WoYiYueDuBingTongYi">
                      <template #tos>
                        <el-link class="sy_reg_atc" type="primary" :href="$urls.dtranxUrl + '/home/UserAgreement?locale=' + language" target="_blank">
                          {{ $t('YongHuXieYi') }}
                        </el-link>
                      </template>
                      <template #privacy>
                        <el-link type="primary" class="sy_reg_atc" :href="$urls.dtranxUrl + '/home/PrivacyPolicy?locale=' + language" target="_blank">
                          {{ $t('YinSiShengMing') }}
                        </el-link>
                      </template>
                    </i18n>
                  </el-checkbox>
                </el-form-item>
                <el-form-item class="protocol">
                  <el-checkbox v-model="isKeepMore" :disabled="btnStatus.loginNoteBtn">{{ $t('30TianNeiJiZhuWo') }}</el-checkbox>
                </el-form-item>
                <el-form-item size="large" style="margin-bottom: 12px">
                  <el-button type="primary" class="loginBtn" @click="pwdSubmit" :loading="btnStatus.loginPwdBtn">{{ $t('DengLu') }}</el-button>
                </el-form-item>
                <div @click="toPath('/forgetPwd')" style="color: var(--font-color);font-size: 16px;cursor: pointer;text-align: center;">{{ $t('WangJiMiMa') }}</div>
              </el-form>
            </div>
          </div>
          <div class="sy_login_bottom" v-if="['tel', 'pwd'].includes(loginType)">
            <span v-if="windowInnerWidth > 499" class="others-login">
              {{ $t('QiTaDengLuFangShi') }}：
              <img @click="goOthersLogin('wx')" src="../../assets/img/weixin-icon.png" alt="">
              <img @click="goOthersLogin('dd')" src="../../assets/img/dingding-icon.png" alt="">
            </span>
            <a type="primary" @click="toPath('/register')" href="javascript:;">{{ $t('ZhuCeZhangHao') }} <i class="el-icon-right"></i></a>
          </div>
        </div>
      </div>
    </div>
<!--    <loginFooter></loginFooter>-->
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import loginHeader from '@/components/loginPublic/loginHeader'
import loginFooter from '@/components/loginPublic/loginFooter'
import DDLogin from '@/components/loginPublic/DDLogin.vue'

export default {
  name: 'login',
  components: { DDLogin, loginHeader, loginFooter },
  data () {
    var checkTelEmail = (rule, value, callback) => {
      this.toRegister = false
      if (!value) {
        this.checkTelEmailErrorMsg = this.$t('QingShuRuShouJiHaoYouXiang')
        callback(new Error(this.checkTelEmailErrorMsg))
      } else if (!(/^1[3-9][0-9]{9}$/).test(value) && !/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
        this.checkTelEmailErrorMsg = this.$t('QingShuRuZhengQueDeShouJiHaoYouXiang')
        callback(new Error(this.checkTelEmailErrorMsg))
      } else {
        if (this.loginType === 'pwd') {
          this.getUserIsExistFn(value).then((res) => {
            if (res.success) {
              this.toRegister = true
              this.checkTelEmailErrorMsg = this.$t('GaiShouJiHaoYouXiangWeiZhuCe')
              callback(new Error(this.checkTelEmailErrorMsg))
            } else {
              this.toRegister = false
              callback()
            }
          }).catch(() => {
            this.toRegister = false
            callback()
          })
        } else {
          callback()
        }
      }
    }
    var validateCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('QingShuRuTuXingYanZhengMa')))
      } else if (!(/^\S{4}$/).test(value)) {
        callback(new Error(this.$t('TuXingYanZhengMaCuoWuQingZhongXinShuRu')))
      } else {
        callback()
      }
    }
    var validateTelCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('QingShuRuYanZhengMa')))
      } else if (!(/^[0-9]{6}$/).test(value)) {
        callback(new Error(this.$t('YanZhengMaCuoWuQingZhongXinShuRu')))
      } else {
        callback()
      }
    }
    var checktel = (rule, value, callback) => {
      this.toRegister = false
      if (!value) {
        this.checkTelEmailErrorMsg = this.$t('QingShuRuShouJiHao')
        return callback(new Error(this.checkTelEmailErrorMsg))
      } else if (!(/^1[3-9][0-9]{9}$/).test(value)) {
        this.checkTelEmailErrorMsg = this.$t('QingShuRuZhengQueDeShouJiHao')
        callback(new Error(this.checkTelEmailErrorMsg))
      } else {
        if (this.loginType === 'pwd') {
          this.getUserIsExistFn(value).then((res) => {
            if (res.success) {
              this.toRegister = true
              this.checkTelEmailErrorMsg = this.$t('GaiShouJiHaoWeiZhuCe')
              callback(new Error(this.checkTelEmailErrorMsg))
            } else {
              this.toRegister = false
              callback()
            }
          }).catch(() => {
            this.toRegister = false
            callback()
          })
        } else {
          callback()
        }
      }
    }
    var validatePwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('QingShuRuMiMa')))
      } else {
        callback()
      }
    }
    const checked = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('QingGouXuanTongYiXiangGuanTiaoKuan')))
      } else {
        callback()
      }
    }
    return {
      codeTimer: 0,
      isShuYi: '',
      loginType: 'tel',
      toRegister: false,
      isKeepMore: false,
      telForm: {
        tel: '',
        verificationCode: '',
        telVerificationCode: '',
        checked: false
      },
      noteCodeInterval: null,
      noteCodeBtn: false,
      // sending: '60秒后重新发送',
      pwdForm: {
        telEmail: '',
        telPwd: '',
        verificationCode: '',
        checked: false
      },
      showPwdIcon: false,
      checkTelEmailErrorMsg: '',
      rules: {
        tel: [
          { validator: checkTelEmail, trigger: 'blur' }
        ],
        verificationCode: [
          { validator: validateCode, trigger: 'blur' }
        ],
        telVerificationCode: [
          { validator: validateTelCode, trigger: 'blur' }
        ],
        checked: [
          { type: 'boolean', required: true, validator: checked, trigger: 'change' }
        ]
      },
      pwdRules: {
        telEmail: [
          { validator: checkTelEmail, trigger: 'blur' }
        ],
        telPwd: [
          { validator: validatePwd, trigger: 'blur' }
        ],
        verificationCode: [
          { validator: validateCode, required: false, trigger: 'blur' }
        ],
        checked: [
          { type: 'boolean', required: true, validator: checked, trigger: 'change' }
        ]
      },
      QrCode: '',
      wxTimer: null,
      windowInnerWidth: 1200
    }
  },
  methods: {
    ...mapMutations(['showMsg']),
    ...mapActions(['loginChangeCodeFn', 'getNoteCodeFn', 'pwdLoginFn', 'getEmailCodeFn', 'telNoteLoginFn', 'getWXLoginQRCodeFn', 'getWXLoginOpenIdFn',
      'getWXIsBindUserFn', 'WXLoginFn', 'getUserIsExistFn']),
    goOthersLogin (type) {
      const isUnChecked = (this.loginType === 'tel' && !this.telForm.checked) ||
        (this.loginType === 'pwd' && !this.pwdForm.checked)

      if (isUnChecked) {
        this.showAgreementConfirm(type)
      } else {
        this.typeChange(type)
      }
    },
    showAgreementConfirm (type) {
      const baseUrl = this.$urls.dtranxUrl
      const locale = this.language

      const agreementLink = `<a href="${baseUrl}/home/UserAgreement?locale=${locale}" target="_blank">${this.$t('YongHuXieYi')}</a>`
      const privacyLink = `<a href="${baseUrl}/home/PrivacyPolicy?locale=${locale}" target="_blank">${this.$t('YinSiShengMing')}</a>`

      const message = `
                        ${this.$t('QingYueDu')}
                        ${agreementLink}
                        ${this.$t('He')}
                        ${privacyLink}
                        ${this.$t('QingYueDu2')}
                      `

      this.$confirm(message, this.$t('YongHuXieYiJiYinSiShengMing'), {
        dangerouslyUseHTMLString: true,
        closeOnClickModal: false,
        confirmButtonText: this.$t('TongYi'),
        cancelButtonText: this.$t('BuTongYi'),
        type: 'warning'
      }).then(() => {
        this.typeChange(type)
      }).catch(() => {})
    },
    getOpenIdFunc () {
      this.wxTimer = setInterval(() => {
        this.getWXLoginOpenIdFn('').then((res) => {
          clearInterval(this.wxTimer)
          this.getWXIsBind(res.data)
        }).catch(() => {})
      }, 3000)
    },
    toRegisterFn () {
      this.$router.push('/register?tel=' + encodeURIComponent(this.pwdForm.telEmail))
    },
    typeChange (item) {
      this.toRegister = false
      this.isKeepMore = false
      this.loginType = item
      if (item === 'wx') {
        if (!this.QrCode) {
          this.getWXLoginQRCodeFn().then((res) => {
            this.QrCode = 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + res.data.ticket
            this.getOpenIdFunc()
          }).catch(() => {})
        } else {
          this.getOpenIdFunc()
        }
      } else {
        this.wxTimer && clearInterval(this.wxTimer)
      }
      if (item === 'tel') {
        if (this.showCaptcha.codeLogin) {
          this.loginChangeCodeFn('loginNoteImgCode')
        }
        this.$refs.loginTelForm.clearValidate()
      }
      if (item === 'pwd') {
        if (this.showCaptcha.pwdLogin) {
          this.loginChangeCodeFn('loginPwdImgCode')
        }
        this.$refs.loginPwdForm.clearValidate()
      }
    },
    getWXIsBind (oid) {
      this.getWXIsBindUserFn(oid).then((res) => {
        if (res.success && res.data) {
          // 已绑定 直接登录
          let wxLogin = {
            userAccount: res.data,
            wxOpenId: oid,
            source: this.loginSource.buryingPoint,
            isKeepMore: this.isKeepMore
          }
          this.WXLoginFn(wxLogin).then((res) => {
            let token = res.data.Authentication
            this.loginIsSuccessfullyRedirected(token)
          }).catch((res) => {
            this.showMsg({ msg: (res.msg || this.$t('HuoQuWeiXinQuanXianShiBaiQingZhongXinSaoMaDengLu', [this.$t('weiXin')])), type: 'error' })
          })
        } else {
          // 未绑定 去绑定
          this.$router.push(`/wxLogin?code=${oid}&type=wx`)
        }
      }).catch(() => {
        this.showMsg({ msg: this.$t('HuoQuWeiXinQuanXianShiBaiQingZhongXinSaoMaDengLu', [this.$t('weiXin')]), type: 'error' })
      })
    },
    getTelCode () {
      this.NoteCodeData.loginNoteCodeKey = ''
      this.getNoteCodeFn({
        imageCode: this.telForm.verificationCode,
        imageCodeKey: this.imgCodeData.loginNoteImgCodeKey,
        account: this.telForm.tel,
        origin: 'codeLogin'
      }).then((response) => {
        this.NoteCodeData.loginNoteCodeKey = response.data.SMSCodeKey
        this.codeTimer = 120
        this.noteCodeBtn = true
        this.noteCodeInterval = setInterval(() => {
          if (this.codeTimer > 0) {
            this.codeTimer--
          } else {
            this.noteCodeBtn = false
            clearInterval(this.noteCodeInterval)
          }
        }, 1000)
      }).catch((response) => {
        this.loginChangeCodeFn('loginNoteImgCode')
        this.noteCodeBtn = false
      })
    },
    getNoteCode () {
      this.noteCodeBtn = true
      this.$refs.loginTelForm.validateField('tel', (val, item) => {
        // console.log(val)
        if (!val) {
          if (this.showCaptcha.codeLogin) {
            this.$refs.loginTelForm.validateField('verificationCode', (val, item) => {
              if (!val) {
                this.getTelCode()
              } else {
                this.noteCodeBtn = false
              }
            })
          } else {
            this.getTelCode()
          }
        } else {
          this.noteCodeBtn = false
        }
      })
    },
    telSubmit () {
      this.$refs.loginTelForm.validate((valid) => {
        if (valid) {
          let telData = {
            userAccount: this.telForm.tel,
            code: this.telForm.telVerificationCode,
            codeKey: this.NoteCodeData.loginNoteCodeKey,
            source: this.loginSource.buryingPoint,
            isKeepMore: this.isKeepMore
          }
          this.telNoteLoginFn(telData).then((res) => {
            if (res.success) {
              let token = res.data.Authentication
              this.loginIsSuccessfullyRedirected(token)
            }
          }).catch(() => {})
        } else {
          return false
        }
      })
    },
    showPwdFn () {
      this.showPwdIcon = !this.showPwdIcon
    },
    pwdSubmit () {
      this.$refs.loginPwdForm.validate((valid) => {
        if (valid) {
          let pwdData = {
            userAccount: this.pwdForm.telEmail,
            password: this.util.encodeToBase64(this.pwdForm.telPwd),
            code: this.pwdForm.verificationCode,
            codeKey: this.imgCodeData.loginPwdImgCodeKey,
            source: this.loginSource.buryingPoint,
            isKeepMore: this.isKeepMore
          }
          this.pwdLoginFn(pwdData).then((res) => {
            let token = res.data.Authentication
            this.loginIsSuccessfullyRedirected(token)
          }).catch(() => {
          })
        } else {
          return false
        }
      })
    },
    toPath (item) {
      this.$router.push(item)
    },
    getCookie (name) {
      let arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'))
      if (arr != null) return unescape(arr[2])
      return null
    },
    loginIsSuccessfullyRedirected (token) {
      this.setCookie('DTRANXTOKEN', token)
      if (this.isPopFrame) {
        this.$nextTick(() => {
          this.$refs.closeModalBtn.sendMsgOfSuccess(token)
        })
      } else {
        window.location.href = `${this.loginSource.url}`
      }
    }
  },
  mounted () {
    const token = this.getCookie('DTRANXTOKEN')
    if (token) {
      this.loginIsSuccessfullyRedirected(token)
    }
    this.windowInnerWidth = window.innerWidth
    let that = this
    // let obj = new WxLogin({
    //   self_redirect: false,
    //   id: 'login_container',
    //   // appid: 'wxec971e727c5f2250', // 集成
    //   // appid: 'wxa8a01fb573ed2c46', // 正式
    //   appid: that.$urls.wxAppid,
    //   scope: 'snsapi_login',
    //   // redirect_uri: encodeURIComponent('https://shuyilogin_uat.dtranx.com/#/wxLogin'), // 集成
    //   // redirect_uri: encodeURIComponent('https://login.dtranx.com/#/wxLogin'), // 正式
    //   redirect_uri: encodeURIComponent(that.$urls.wxRedirectUri),
    //   state: '',
    //   style: '',
    //   href: window.location.origin + '/style/wxReset.css'
    // })
    // this.loginChangeCodeFn('loginNoteImgCode')
    clearInterval(this.noteCodeInterval)
    window.onkeydown = function (event) {
      let e = event || window.event
      if (e.type === 'keydown' && (e.code === 'Enter' || e.code === 'NumpadEnter')) {
        e.preventDefault()
        if (that.loginType === 'tel' && !that.btnStatus.loginNoteBtn) {
          that.telSubmit()
        }
        if (that.loginType === 'pwd' && !that.btnStatus.loginPwdBtn) {
          that.pwdSubmit()
        }
      }
    }
  },
  destroyed () {
    clearInterval(this.noteCodeInterval)
    window.onkeydown = null
  },
  created () {
    this.windowInnerWidth = window.innerWidth
    this.noteCodeBtn = false
    let regTel = this.$route.query
    if (regTel && regTel.tel) {
      this.loginType = 'tel'
      this.telForm.tel = regTel.tel
    }

    window.onresize = () => {
      this.windowInnerWidth = window.innerWidth
      if (this.windowInnerWidth <= 499 && this.loginType === 'wx') {
        this.wxTimer && clearInterval(this.wxTimer)
        this.loginType = 'tel'
        this.loginChangeCodeFn('loginNoteImgCode')
      }
    }
  },
  computed: {
    SFName () {
      return this.loginType === 'wx' ? this.$t('weiXin') : this.$t('dingDing')
    },
    ...mapState({
      isPopFrame: state => state.publicModules.isPopFrame,
      language: state => state.publicModules.language,
      loginSource: state => state.publicModules.loginSource,
      modal: state => state.loginPublic.modal,
      imgCodeData: state => state.loginPublic.imgCodeData,
      NoteCodeData: state => state.loginPublic.NoteCodeData,
      btnStatus: state => state.loginPublic.btnStatus,
      showCaptcha: state => state.loginPublic.showCaptcha
    }),
    telCodeText () {
      if (this.codeTimer > 0) {
        return this.$t('TimerMiaoHouZhongXinFaSong', [this.codeTimer])
      }
      return this.$t('HuoQuYanZhengMa')
    }
  },
  watch: {

  }
}
</script>

<style scoped lang="scss">
@keyframes wx_load {
  0% {transform: rotate(0);}
  100% {transform: rotate(360deg);}
}
.login_content {
  .login_cont {
    #login_container{
      text-align: center;
      box-sizing: border-box;
      margin-top: 32px;
      padding-top: 46px;
      padding-bottom: 24px;
     .loadCont{
       padding-top: 84px;
     }
     .wx_loading{
       width: 220px;
       height: 144px;
       margin: auto;
       box-sizing: border-box;
       .load{
         box-sizing: border-box;
         margin: 0 auto;
         padding: 2px;
         width: 48px;
         height: 48px;
         border-radius: 50%;
         background: linear-gradient(315deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 17%, rgba(255,255,255,0.89) 59%, var(--primary-color) 100%);
         animation-name: wx_load;
         animation-duration: 1s;
         animation-timing-function: linear;
         animation-iteration-count: infinite;
         animation-fill-mode: both;
         .load_white{
           box-sizing: border-box;
           width: 44px;
           height: 44px;
           margin: auto;
           background: #FFFFFF;
           border-radius: 50%;
         }
       }
     }
    }
    .wx_text{
      color: #999999;
      font-size: 14px;
      text-align: center;
    }
    .remember_me{
      /deep/
      .el-checkbox__input+.el-checkbox__label,
      .el-checkbox__input.is-checked+.el-checkbox__label{
        color: var(--font-color2);
      }
    }
    .others-login{
      img{
        width: 24px;
        &+img{
          margin-left: 8px;
        }
      }
    }
  }
}
@media (min-width: 500px) {
  .login_content{
    &.isPopFrame{
      min-height: 590px;
    }
    //.login_form_cont{
    //  min-height: 380px;
    //}
  }
}
@media (max-width: 499px) {
  .login_contenter{
    .login_content{
      .login_cont{
        .login_form{
          .login_form_cont{
            min-height: 344px;
          }
        }
      }
    }
  }
}
</style>
